/**
 * Device detection utilities
 * Used for phone link behavior: Desktop → /contact, Mobile → tel:
 */

export const isMobileDevice = () =>
  typeof window !== "undefined" &&
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
